import React from "react";
import CardOne from "../../../../Components/Cards/CardOne";
import { GridWrapper } from "../../../../Components/Cards/CardOne/styles";
import {
  Container,
  FlexWrapper,
  Text1,
  Text3,
  Text4,
  Text4_5,
  Text5,
  Text5_6,
  Text6,
} from "../../../../Components/Common";
// images
import UserOneImage from "../../../../Assets/users/user1.png";
import ScribbleImgae1 from "../../../../Assets/scribbleimage1.png";
import BackgroundImage from "../../../../Assets/BG.svg";
import BackgroundSecondImage from "../../../../Assets/bg/homepage-image3.png";
import {
  BackgroundImageContainer,
  CardTwoHeading,
  CardTwoWrapper,
  EscribelohighBackgroundConatiner,
  EscribeloWritesContainer,
  NumberText,
  ReverseFlexContainer,
  ScribbleImageLogo,
} from "./styles";
import WhoIsComponent from "../../../../Components/Template/WhoIsComponent";
import TempeleteOne from "../../../../Components/Template/Templete1";
import CustomGrid from "../../../../Components/CustomGrid";
import ScrollAnimation from "react-animate-on-scroll";

const SectionTwo = () => {
  return (
    <>
      <Container width={"90%"} margin={"50px auto 0px auto"}>
        <Text3 color={"white"} weight={"bold"}>
          Join over 10,000+ copywriters, entrepreneurs,
          <br /> and agencies
        </Text3>
        <Container width={"100%"} padding={"0px"}>
          <ScrollAnimation animateIn="fadeIn" duration={1.5} delay={100}>
            <CustomGrid isViewMoreIcon={true} isViewMoreButton={false}/>
          </ScrollAnimation>
        </Container>

        <ScrollAnimation animateIn="fadeIn" duration={1.5} delay={100}>
          <ReverseFlexContainer margin={"80px auto"} justify={"center"}>
            <ScribbleImageLogo src={ScribbleImgae1} />
            <Container padding={"0rem"} wdith={"60%"}>
              <FlexWrapper direction={"column"} width={"100%"}>
                <Text3 color={"white"} weight={900} fontFamily={"Inter"}>
                  Hello, I'm Scribble – your new AI content assistant.
                </Text3>
                <Text5
                  color={"white"}
                  margin={"20px auto"}
                  className={"hide_at_mobile"}
                  weight={600}
                >
                  Forget about endless hours spent trying writing blog posts,
                  marketing emails, <br /> and sales pages. Now you can let your
                  new AI content <br /> assistant, Jarvis, do it for you.
                </Text5>
              </FlexWrapper>
            </Container>
          </ReverseFlexContainer>
        </ScrollAnimation>
      </Container>
      <ScrollAnimation animateIn="fadeIn" duration={1} delay={100}>
        <EscribelohighBackgroundConatiner>
          <EscribeloWritesContainer padding={"100px 0px"}>
            <FlexWrapper direction={"column"} align={"center"}>
              <Text3
                color={"white"}
                weight={900}
                margin={"30px auto 40px auto"}
              >
                Escribelo writes high-converting copy (like this)
              </Text3>
              <FlexWrapper
                margin={"20px auto"}
                justify={"space-between"}
                gap={"50px"}
                wrap={"wrap"}
              >
                {Array.from(Array(5).keys()).map((item, index) => (
                  <CardTwoWrapper>
                    <CardTwoHeading align={"left"} weight={"bold"}>
                      Save hours writing clever, original content
                    </CardTwoHeading>
                    <Text6
                      color={"white"}
                      align={"left"}
                      margin={"10px 0"}
                      weight={510}
                    >
                      Tired of spending hours writing and revising copy? Start
                      with Jarvis – you may not even need editing!
                    </Text6>
                  </CardTwoWrapper>
                ))}
                <FlexWrapper
                  direction={"column"}
                  width={"300px"}
                  margin={"0 auto"}
                  gap={"20px"}
                >
                  <CardTwoWrapper padding={"15px 25px"}>
                    <CardTwoHeading align={"left"} weight={"bold"}>
                      Mobile friendly app to write on the go
                    </CardTwoHeading>
                  </CardTwoWrapper>
                  <CardTwoWrapper padding={"15px 25px"}>
                    <CardTwoHeading align={"left"} weight={"bold"}>
                      Mobile friendly app to write on the go
                    </CardTwoHeading>
                  </CardTwoWrapper>
                </FlexWrapper>
              </FlexWrapper>
            </FlexWrapper>
          </EscribeloWritesContainer>
        </EscribelohighBackgroundConatiner>
      </ScrollAnimation>
      <ScrollAnimation animateIn="fadeIn" duration={1} delay={100}>
        <WhoIsComponent heading={"Who is esribelo a perfect fit for?"} />
      </ScrollAnimation>
      <ScrollAnimation animateIn="fadeIn" duration={1} delay={100}>
        <div style={{ width: "100%", padding: "50px 0px" }}>
          <TempeleteOne
            heading1={"Rated 4.9/5 Stars With"}
            heading2={" 10,000+ Customers"}
            ButtonTitle={"Read Customer reviews"}
            backgroundUrl={BackgroundSecondImage}
          />
        </div>
      </ScrollAnimation>

      {/* How it Work Section */}
      <ScrollAnimation animateIn="fadeIn" duration={1} delay={100}>
        <Container>
          <FlexWrapper direction={"column"} margin={"20px auto"}>
            <Text5 color={"white"} weight={"600"} fontfamily={"Inter"}>
              How It Works
            </Text5>
            <Text4 color={"white"} weight={800} fontfamily={"Inter"}>
              How Escribelo writes your copy
            </Text4>
            <FlexWrapper direction={"row"} gap={"40px"} margin={"20px auto"}>
              <FlexWrapper direction={"column"}>
                <NumberText color={"#06D9CA"} weight={800} fontfamily={"Inter"}>
                  {"1"}
                </NumberText>
                <Text4_5 color={"white"} weight={700} margin={"0px auto"}>
                  {"Choose a skill"}
                </Text4_5>
                <Text5_6 color={"white"}>
                  Jarvis is trained by copywriters and conversion experts with
                  rules to follow and models to mimic."
                </Text5_6>
              </FlexWrapper>

              <FlexWrapper direction={"column"}>
                <NumberText color={"#19B6F0"} weight={800} fontfamily={"Inter"}>
                  {"2"}
                </NumberText>
                <Text4_5
                  color={"white"}
                  weight={700}
                  margin={"0px auto"}
                  margin={"0px auto"}
                >
                  {"Choose a skill"}
                </Text4_5>
                <Text5_6 color={"white"} weight={500}>
                  Jarvis is trained by copywriters and conversion experts with
                  rules to follow and models to mimic."
                </Text5_6>
              </FlexWrapper>

              <FlexWrapper direction={"column"}>
                <NumberText color={"#6E6CFF"} weight={800} fontfamily={"Inter"}>
                  {"3"}
                </NumberText>
                <Text4_5
                  color={"white"}
                  weight={700}
                  margin={"0px auto"}
                >
                  {"Choose a skill"}
                </Text4_5>
                <Text5_6 color={"white"}>
                  Jarvis is trained by copywriters and conversion experts with
                  rules to follow and models to mimic."
                </Text5_6>
              </FlexWrapper>
            </FlexWrapper>
          </FlexWrapper>
        </Container>
      </ScrollAnimation>
    </>
  );
};

export default SectionTwo;
